export const GET_VEHICLE_DAILY_SUMMARY_REPORTS = "V3_GET_VEHICLE_DAILY_SUMMARY_REPORTS" 
export const GET_VEHICLE_SUMMARY_REPORTS = "V3_GET_VEHICLE_SUMMARY_REPORTS" 
export const CLEAR_VEHICLE_DAILY_SUMMARY_REPORTS = "V3_CLEAR_VEHICLE_DAILY_SUMMARY_REPORTS" 
export const GET_VEHICLE_FUEL_ANALYSIS_REPORTS = "V3_GET_VEHICLE_FUEL_ANALYSIS_REPORTS"
export const CLEAR_VEHICLE_FUEL_ANALYSIS_REPORTS = "V3_CLEAR_VEHICLE_FUEL_ANALYSIS_REPORTS"
export const GET_VEHICLE_GEOFENCE_REPORTS = "V3_GET_VEHICLE_GEOFENCE_REPORTS" 
export const GET_VEHICLE_REFUEL_REPORTS = "V3_GET_VEHICLE_REFUEL_REPORTS" 
export const GET_VEHICLE_UTILISATION_REPORTS = "V3_GET_VEHICLE_UTILISATION_REPORTS" 
export const CLEAR_VEHICLE_UTILISATION_REPORTS = "V3_CLEAR_VEHICLE_UTILISATION_REPORTS" 